import React from 'react';
import { componentService } from 'js/services/component.service';

export const CashierExternal = React.lazy(() => import(/* webpackChunkName: "cashier-external" */ './CashierExternal'));

componentService.registerPageComponents({ 'cashier-external': CashierExternal });
